export const translations = {
  en: {
    title: 'Subscriber Information',
    label_first_name: 'Subscriber first name',
    label_middle_name: 'Subscriber middle name',
    label_last_name: 'Subscriber last name',
    label_birthdate: 'Subscriber date of birth',
    label_sex: 'Subscriber sex',
    label_address_1: 'Subscriber Address line 1',
    label_address_2: 'Subscriber Address line 2',
    label_city: 'Subscriber City',
    label_state: 'Subscriber State',
    label_zip: 'Subscriber Zip',
    label_email: 'Subscriber Email',
    label_phone: 'Subscriber Phone',
    placeholder_first_name: 'Enter first name',
    placeholder_middle_name: 'Enter middle name',
    placeholder_last_name: 'Enter last name',
    placeholder_birthdate: 'MM/DD/YYYY',
    placeholder_address_1: 'Enter address',
    placeholder_city: 'Enter city',
    placeholder_zip: 'Enter Zip',
    placeholder_email: 'Enter Email',
    placeholder_phone: 'Enter phone number',
    error_16_characters: 'Please use 16 characters or less',
    error_26_characters: 'Please use 26 characters or less',
    error_30_characters: 'Please use 30 characters or less',
    error_34_characters: 'Please use 34 characters or less',
    error_10_digits: 'Must be exactly 10 digits',
    error_first_name: 'Please enter a valid first name',
    error_last_name: 'Please enter a valid last name',
    error_no_numbers: 'No numbers or special characters or space allowed',
    error_select_gender: 'Please select gender',
    error_birthdate_required: 'Subscriber date of birth is required',
    error_birthdate: 'Please enter a valid date of birth',
    error_birthdate_format: 'Invalid Date Format',
    error_address_1: 'Please enter line 1 of your address',
    error_city: 'Please enter a city',
    error_state: 'Please select a valid State',
    error_zip: 'Please enter a valid zip code',
    error_only_digits: 'Must be only digits',
    error_valid_zip: 'Must be a valid zip',
    error_email: 'Please enter a valid email address',
    error_valid_email: 'Please enter a valid email',
    error_phone: 'Please enter a valid phone number',
    error_phone_format: 'Must be exactly 10 digits',
    tooltip:
      'This is the legal sex marker on your insurance/health record/drivers license, which may differ from your current gender identity.'
  },
  es: {
    title: 'Información del suscriptor',
    label_first_name: 'Primer nombre del suscriptor',
    label_middle_name: 'Segundo nombre del suscriptor',
    label_last_name: 'Apellido del suscriptor',
    label_birthdate: 'Fecha de nacimiento del suscriptor',
    label_sex: 'Sexo del suscriptor',
    label_address_1: 'Dirección 1 del suscriptor: calle',
    label_address_2: 'Dirección 2 del suscriptor: número de calle',
    label_city: ' Ciudad del suscriptor',
    label_state: 'Estado del suscriptor',
    label_zip: 'Código postal',
    label_email: 'Email del suscriptor',
    label_phone: 'Teléfono del suscriptor',
    placeholder_first_name: 'Introduzca primer nombre',
    placeholder_middle_name: 'Introduzca segundo nombre',
    placeholder_last_name: 'Introduzca apellido',
    placeholder_birthdate: 'MM/DD/AAAA',
    placeholder_address_1: 'Introduzca la primera calle',
    placeholder_city: 'Introduzca la ciudad',
    placeholder_zip: 'Introduzca código postal',
    placeholder_email: 'Introcuzca email',
    placeholder_phone: 'Introduzca teléfono',
    error_16_characters: 'Por favor use 16 caracteres o menos',
    error_26_characters: 'Por favor use 26 caracteres o menos',
    error_30_characters: 'Por favor use 30 caracteres o menos',
    error_34_characters: 'Por favor use 34 caracteres o menos',
    error_10_digits: 'Debe ser exactamente 10 dígitos',
    error_first_name: 'Por favor introduzca un primer nombre válido',
    error_last_name: 'Por favor introduzca un apellido válido',
    error_no_numbers: 'Números, carácteres especiales o espacios no son permitidos.',
    error_select_gender: 'Por favor seleccione el sexo',
    error_birthdate_required: 'Fecha de nacimiento es requerida',
    error_birthdate: 'Por favor introduzca fecha de nacimiento válida',
    error_birthdate_format: 'Formato de fecha inválido',
    error_address_1: 'Por favor introduzca la primera calle de su dirección',
    error_city: 'Por favor introduzca la ciudad',
    error_state: 'Por favor seleccione un estado válido',
    error_zip: 'Por favor introduzca código postal válido',
    error_only_digits: 'Deben ser sólo números',
    error_valid_zip: 'Debe ser un código postal válido',
    error_email: 'Por favor introduzca un email válido',
    error_valid_email: 'Por favor introduzca un email válido',
    error_phone: 'Por favor introduzca teléfono válido',
    error_phone_format: 'Debe ser exactamente 10 dígitos',
    tooltip:
      'Esta es la identificación legal de sexo que se encuentra en su licencia de conducir, registros médicos o de seguro, la cual puede ser diferente a su identidad sexual actual.'
  }
};
